export default "__VITE_ASSET__$6$fxSoT__"